import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const TeamCoaches = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      <main className="container mx-auto px-4 py-8" style={{paddingTop: '100px'}}>
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-sports-green mb-8">Manage Coaches</h1>
          <div className="bg-gray-900 rounded-lg p-6">
            <p className="text-gray-300 mb-4">
              This is the Team Coaches management page. Here you can manage your coaching staff, 
              assign roles, and coordinate coaching activities.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="bg-gray-800 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-sports-green mb-2">Coaching Staff</h3>
                <p className="text-gray-400 text-sm">View and manage your coaching team</p>
              </div>
              <div className="bg-gray-800 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-sports-green mb-2">Role Assignment</h3>
                <p className="text-gray-400 text-sm">Assign specific roles to coaches</p>
              </div>
              <div className="bg-gray-800 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-sports-green mb-2">Coach Performance</h3>
                <p className="text-gray-400 text-sm">Track coaching effectiveness and feedback</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TeamCoaches;